import type { VFC } from 'react'
import { LayoutWithSidebar } from '../layoutWithSidebar'
import { Form } from './form'
import { AccountCreationProps } from './types'

export const AccountCreation: VFC<AccountCreationProps> = ({
  companyName,
  currentAvatarUuid,
  currentEmailAddress,
  currentFamilyName,
  currentGivenName,
  currentJobTitle,
  exampleFamilyName,
  exampleGivenName,
  passwordRules,
  ssoIdpName,
  ssoStatus,
  ssoUrl,
  theme = 'light',
  tosAccepted,
  userId,
}) => (
  <LayoutWithSidebar theme={theme}>
    <Form
      companyName={companyName}
      currentAvatarUuid={currentAvatarUuid}
      currentEmailAddress={currentEmailAddress}
      currentFamilyName={currentFamilyName}
      currentGivenName={currentGivenName}
      currentJobTitle={currentJobTitle}
      exampleFamilyName={exampleFamilyName}
      exampleGivenName={exampleGivenName}
      passwordRules={passwordRules}
      ssoIdpName={ssoIdpName}
      ssoStatus={ssoStatus}
      ssoUrl={ssoUrl}
      theme={theme}
      tosAccepted={tosAccepted}
      userId={userId}
    />
  </LayoutWithSidebar>
)
AccountCreation.displayName = 'Ex Astra: AccountCreation'
